<div class="admin-container">

    <h2 class="text-center">Workshop</h2>

    <form [formGroup]="form" (ngSubmit)="submit()">

        <div class="d-flex flex-column mb-2">
            <label class="form-label fw-bold">Title *</label>
            <input class="form-control" formControlName="title">
            @if (form.get('title')?.touched && form.get('title')?.hasError('required')) {
            <span class="text-danger">Please enter a workshop title *</span>
            }
        </div>

        <div class="d-flex flex-column mb-2">
            <label class="form-label fw-bold">Description *</label>
            <textarea formControlName="description" class="form-control"></textarea>
            @if (form.get('description')?.touched && form.get('description')?.hasError('required')) {
            <span class="text-danger">Description is required. Please provide a brief overview of the workshop. *</span>
            }
        </div>

        <div class="d-flex flex-column mb-2">
            <div class="form-group mb-2">
                <label class="form-label fw-bold">Price *</label>
                <input type="number" class="form-control" formControlName="price">
                @if (form.get('price')?.touched && form.get('price')?.hasError('required')) {
                <span class="text-danger">Please enter a valid price (numbers only).*</span>
                }
            </div>

            <div class="form-group mb-2">
                <label class="form-label fw-bold">Old Price *</label>
                <input type="number" class="form-control" formControlName="oldPrice">
                @if (form.get('oldPrice')?.touched && form.get('oldPrice')?.hasError('required')) {
                <span class="text-danger">Old price must be greater than or equal to 0.*</span>
                }
            </div>
        </div>

        <div class="d-flex flex-column mb-2">
            <label class="form-label fw-bold">Date (From - To) *</label>
            <p-datepicker pStyleClass="w-100" formControlName="date" selectionMode="range" [readonlyInput]="true" />
            <!-- <input type="date" class="form-control" formControlName="date" /> -->

            @if (form.get('date')?.touched && form.get('date')?.hasError('required')) {
            <span class="text-danger">Please select a workshop date. *</span>
            }
            @if (form.get('date')?.touched && form.get('date')?.hasError('rangeIncomplete')) {
            <span class="text-danger">
                Please select both start and end dates.
            </span>
            }
        </div>
        <div class="d-flex flex-column mb-2">
            <label for="form-label" class="font-bold block mb-2"> Time (From) * </label>
            <p-datepicker inputId="calendar-timeonly" formControlName="timeFrom" [timeOnly]="true"
                [hourFormat]="'12'" />
            @if (form.get('timeFrom')?.touched && form.get('timeFrom')?.hasError('required')) {
            <span class="text-danger">Please select start time. *</span>
            }
        </div>

        <div class="d-flex flex-column mb-2">
            <label class="form-label fw-bold">Time (To) *</label>
            <p-datepicker inputId="calendar-timeonly" formControlName="timeTo" [timeOnly]="true" [hourFormat]="'12'" />
            @if (form.get('timeTo')?.touched && form.get('timeTo')?.hasError('required')) {
            <span class="text-danger">Please select end time. *</span>
            }
        </div>
        <div class="form-group mb-2">
            <label class="form-label">Workshop Format</label>
            <div class="d-flex gap-4">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" formControlName="online" id="online">
                    <label class="form-check-label" for="online">
                        Online
                    </label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" formControlName="offline" id="offline">
                    <label class="form-check-label" for="offline">
                        Offline
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group mb-2">
            <label class="form-label">Meeting Link</label>
            <input type="url" formControlName="workshopLink" class="form-control" />

            @if (form.get('workshopLink')?.touched && form.get('workshopLink')?.hasError('required')) {
            <span class="text-danger">Please provide a meeting link for online workshops. *</span>
            } @if(form.get('workshopLink')?.touched && form.get('workshopLink')?.hasError('pattern')) {
            <span class="text-danger">Please enter a valid URL for the online workshop. *</span>
            }
        </div>
        <div class="form-group mb-2">
            <label class="form-label">Address</label>
            <textarea formControlName="location" class="form-control"></textarea>
            @if (form.get('location')?.touched && form.get('location')?.hasError('required')) {
            <span class="text-danger">Please enter address for offline workshops. *</span>
            }
        </div>
        <div class="form-group mb-2">
            <label class="form-label fw-bold">Seats *</label>
            <input formControlName="seats" class="form-control" type="number">
            @if (form.get('seats')?.touched && form.get('seats')?.hasError('required')) {
            <span class="text-danger">This field is required *</span>
            }
        </div>

        <!-- <div class="form-group">
            <label>What to Expect (one line each)</label>
            <textarea formControlName="whatToExpect"></textarea>
            @if (whatToExpect?.hasError('required')) {
            <span>Please specify what participants can expect from this workshop. *</span>
            }
        </div> -->
        <div class="actions">
            <button type="button" class="btn-cancel" (click)="cancel()">
                Cancel
            </button>

            <button type="submit" class="btn-primary">
                Save
            </button>

        </div>

    </form>
</div>